<template>
    <awesome-table
        :labels="labels"
        :items="history"
        :options="{
            sort: false,
            addButton: false,
            pagination: false,
            searchInput: false,
            filters: false,
            link: false,
            clickableRows: false,
            isCard: false
        }"
    />
</template>

<script>
export default {
    props: {
        history: {
            type: Array,
            required: true
        }
    },

    computed: {
        labels() {
            return [
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                },
                { value: 'value.status', text: 'Status', width: '200px' },
                {
                    value: 'user.fullName',
                    text: 'Changed by',
                    width: '200px'
                }
            ];
        }
    }
};
</script>
